import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: #5f6c77;
  color: #fff;
  padding: 30px 0;
  min-height: calc(100vh - 517px);

  h2 {
    text-align: center;
    margin-bottom: 0;
    margin-top: 20px;
    @media (max-width: 480px){
      font-size: 22px;
    }

    @media (max-width: 768px){
      margin-bottom: 25px;
    }

    p {
      font-size: 18px;
      margin-top: 15px;
      cursor: pointer;

      &:hover {
        color: #edbd2f;
      }
    }

    img {
      max-width: 80px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/system/wrapper/index.js